export default "__VITE_ASSET__BLxDvYpM__"